import { FilterType } from '~/components/filter/filter-options';
import {
	AcurityTable,
	AcurityTableRecord,
	ALL_DATA_LENGTH,
	DataTableRequestFilter,
	DataTablesRequest,
	DataTablesRequestColumn,
} from './acurity-table';

export function createEmptyDataTablesRequest(): DataTablesRequest {
	return {
		columns: [],
		filters: [],
		order: [],
		length: ALL_DATA_LENGTH,
		reverseOrder: false,
		mode: 'data_only',
	};
}

export function createDefaultColumn(
	fieldName: string,
): DataTablesRequestColumn {
	return {
		data: fieldName,
		orderable: true,
		search: { value: '', regex: false },
		searchable: true,
		name: '',
		ignore: false,
	};
}

export function createDefaultFilter(
	fieldName: string,
	value: string,
	operation: FilterType,
): DataTableRequestFilter {
	return {
		data: fieldName,
		ignoreCase: false,
		not: false,
		operation,
		value,
	};
}

export function customHighlight(
	acurityTable: AcurityTable,
	$table: JQuery<HTMLTableElement>,
	highlightCondition: (record: AcurityTableRecord) => boolean,
	highlightClass: string,
): void {
	const dataTable = acurityTable.getDataTable();
	if (!dataTable) {
		return;
	}
	const tableDataSet = dataTable.data() as any as AcurityTableRecord[];
	if (!tableDataSet) {
		return;
	}
	if (tableDataSet.length === 0) {
		return;
	}

	for (const index in tableDataSet) {
		if (isNaN(Number(index)) || !tableDataSet[index]) {
			continue;
		}

		const record: AcurityTableRecord = tableDataSet[index];
		const escapedRowId = $.escapeSelector(
			record.DT_RowId !== undefined ? record.DT_RowId.toString() : '',
		);

		if (highlightCondition(record)) {
			const rowEl = $table.get(0).querySelector('tr#' + escapedRowId);
			if (rowEl) {
				rowEl.classList.add(highlightClass);
			}
		}
	}
}
